import React from 'react';
import SEO from '../../../common/SEO';
import Layout from '../../../common/Layout';
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne';
import RegisterProgramForm from '../../../components/form/register-program-form/RegisterProgramForm';
// import { Link } from 'react-router-dom';

const EventData = [
	{
		"id": 1,
		"title": "Home Energy Data Intelligence",
		"image": "home_energy_data_intelligence.webp",
		// "website": "https://ovet.app/",
		// "industry": "Healthcare",
		// "rating": "4.8 Google Rating",
		// "duration": "12 Weeks",
		"category": "Energy",
		"location": "https://properate.io/",
		// "going": "140+",
		"company": "Properate"
	}
]

const HomeEnergyDataInt = ({
	showRegisterForm,
	setShowRegisterForm,
	company
	}) => {
	const eventItem = EventData[0];
	return (
		<>
			<SEO
				title={ eventItem.title }
				description=""
			/>
			<Layout>
				<BreadcrumbOne 
					title={eventItem.title}
					rootUrl="/programs/work-integrated-learning"
					parentUrl="Industry Partner Work Integrated Learning"
					currentUrl={eventItem.title}
				/>
				<div className="edu-event-details-area edu-event-details edu-section-gap bg-color-white">
					<div className="container">
						<div className="row g-5">
							<div className="col-lg-12">
								<div className="thumbnail">
									<img src={`${process.env.PUBLIC_URL}/images/project-details/${ eventItem.image }`} alt="Event Thumb" />
								</div>
							</div>
						</div>
						<div className="row g-5">
							<div className="col-lg-7">
								<div className="content">
									<h3 className="title">{ eventItem.title }</h3>
									<p>
										<strong>What is the main goal for this project?</strong><br></br>
										This project explores how artificial intelligence can be used to improve energy efficiency in residential buildings. The primary goal is to build a digital platform that automates the interpretation of property-related energy data, helping support faster home energy assessments and data-driven sustainability efforts.
									</p>
									<p className="mb-0">
										<strong>What tasks will learners need to complete to achieve the project goal?</strong><br></br>
									</p>
									<ul>
										<li>
											Prepare and clean structured data related to residential energy systems.
										</li>
										<li>
											Assist in developing cloud-based tools for data integration and validation.
										</li>
										<li>
											Explore techniques such as OCR to extract insights from energy-related documents or images.
										</li>
										<li>
											Support the transformation of datasets into standardized schema formats.
										</li>
										<li>
											Analyze performance data to refine data processing workflows.
										</li>
										<li>
											Contribute to building reusable, modular components for scalable application.
										</li>
									</ul>
									<p className="mb-0">
										These tasks provide learners exposure to clean tech, smart data workflows, and sustainable building analytics.
									</p>
									<p className="mb-0">
										<strong>How will you support learners in completing the project?</strong><br></br>
										Learners will work alongside mentors with experience in AI, cloud computing, and sustainability tech. They'll follow sprint-based learning cycles, use collaborative development tools, and receive regular technical feedback. This supportive environment helps participants build practical skills while contributing to real-world climate and energy solutions.
									</p>
								</div>
							</div>
							<div className="col-lg-5">
								<div className="eduvibe-sidebar">
									<div className="eduvibe-widget eduvibe-widget-details">
										<h5 className="title">ABOUT INDUSTRY PARTNER</h5>
										<div className="widget-content">
											<ul>
												{/* <li><span><i className="icon-Campus"></i> { eventItem.company }</span></li> */}
												<li><span><i className="icon-Campus"></i> <a href={eventItem.location}>{ eventItem.company }</a></span></li>
												<li><span><i className="icon-presentation"></i> { eventItem.category }</span></li>
												{/* <li><span><i className="icon-map-pin-line"></i> {company ? <a href={eventItem.location}>Website</a> : eventItem.location}</span></li> */}
												<li>
													Properate uses AI and spatial computing to simplify home energy upgrades and accelerate Canada's transition to net-zero. The platform empowers homeowners, contractors, and program managers with data-driven insights to optimize retrofit decisions, scale heat pump adoption, and reduce emissions from residential heating and hot water systems.
												</li>
											</ul>
											{!company && <div className="read-more-btn mt--45">
												<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
											</div>}
										</div>
									</div>
								</div>
							</div>
							{!company && <div className="col-lg-12">
								<div className="read-more-btn text-center">
									<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</Layout>
			{showRegisterForm && <RegisterProgramForm setShowRegisterForm={setShowRegisterForm} />}
		</>
	)
}
export default HomeEnergyDataInt;